import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import clsx from "clsx";
// hooks
import useMenuItems from "@/hooks/useMenuItems";
// components
import RMDRLink from "@/components/RMDRLink";

// utilities
import { 
    menuNameDescriptionLanguageVersion, 
    metaDataLanguageVersion,
    redirectUrl 
} from "@/utilities/LanguageVersionSelectorShortcut";
import MenuComposer from "@/utilities/MenuComposer";
// types
import { TMainPageLayoutV3 } from "../type";
import TMenu from "@/cms/types/TMenu";
import TClientMenuItemList from "@/cms/types/TClientMenuItemList";


const Menu = ( props:{payload:TMenu[], webApplicationLanguageISOCode:string} ) => {
    const location = useLocation();

    return (
        <>
            {
                props.payload?.map((item, index) => {
                    const languageVersion = menuNameDescriptionLanguageVersion(item.languageVersions);
                    if ( !languageVersion ) return null;
                    let _redirectUrl = redirectUrl(item.languageVersions)?.value;

                    if ( item.layouts?.[0]?.layoutName === "MN_001" ) _redirectUrl = `/${props.webApplicationLanguageISOCode}`;
                    else if ( item.layouts?.[0]?.layoutName === "MN_002" ) {
                        const redirectPath = metaDataLanguageVersion("redirectPath", item.languageVersions);
                        const redirectUrl = metaDataLanguageVersion("redirectUrl", item.languageVersions);
                        if ( redirectPath ) _redirectUrl = `/${props.webApplicationLanguageISOCode}${redirectPath}`;
                        else if ( redirectUrl ) _redirectUrl = redirectUrl;
                    }
                    
                    return (
                        <li key={item.id} className={clsx({"active":location.pathname === languageVersion.contentRouteNavigationURL})}>
                            <RMDRLink
                                text={null}
                                title={languageVersion?.name}

                                hasNavigationDestination={item.hasDestinationNavigation}

                                navigationURL={languageVersion?.contentRouteNavigationURL}

                                redirectType={item.redirectType}
                                redirectUrl={_redirectUrl}
                                isShowAlways={true}
                                className="cursor-pointer"
                                variant="div"
                            >
                                {languageVersion?.name}
                                { item.items && item.items.length > 0 && (<i className="fas fa-angle-down"></i>)}
                            </RMDRLink>
                            {
                                item.items && item.items.length > 0 && (<ul className="submenu"><Menu payload={item.items} webApplicationLanguageISOCode={props.webApplicationLanguageISOCode} /></ul>)
                            }
                        </li>
                    )
                })
            }
        </>
    )
}

const Render = ( props:{ menuItems:TClientMenuItemList[] } ) => {
    console.log("MNPG049.Render: ", props);
    
    const webApplicationLanguageISOCode = useSelector((state:any) => state.CoreStore.languageCode?.payload, shallowEqual);
    let parentMenuItems = props.menuItems.filter((item:any) => item.parentId === null);
    let navigation = MenuComposer(props.menuItems, parentMenuItems);
    
    if ( !navigation ) return null;

    return (
        <>
            <div className="mean__menu-wrapper">
                <div className="main-menu d-none d-xl-block">
                    <nav id="mobile-menu">
                        <ul>
                            <Menu payload={navigation} webApplicationLanguageISOCode={webApplicationLanguageISOCode} />
                        </ul>
                    </nav>
                </div>
            </div>
        </>
    )

}

const RenderOwnContent = ( props:{unqKey:string, contentLayoutName:string} ) => {
    console.log("MNPG049.RenderOwnContent: ", props);
    
    const menuItems = useMenuItems(props.unqKey, props.contentLayoutName);

    if ( !menuItems ) return null;

    return <Render menuItems={menuItems} />

}

const MNPG049 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG049.rendered: ", props);

    if ( !props.template ) return null;

    const unqKey = props.template.id.split("-")[4];
    return (
        <RenderOwnContent unqKey={unqKey} contentLayoutName={props.template.contentLayoutName} />
    )
}

export default MNPG049;
